/**
 * Abre un documento HTML autónomo en una ventana aparte y lanza la impresión.
 *
 * Aparte y no en la propia página porque lo que se imprime —etiquetas en retícula de
 * milímetros, listados paginados a mano— trae su `@page` y su maquetación, y eso no
 * convive con el layout del panel ni con MUI.
 *
 * Devuelve `false` si el navegador bloqueó la ventana emergente, para que quien llama
 * lo diga en pantalla en vez de fallar en silencio.
 */
export function imprimirDocumento(html) {
  const ventana = window.open('', '_blank');
  if (!ventana) return false;

  ventana.document.write(html);
  ventana.document.close();

  // `complete` implica que también cargaron las imágenes (el logo del campamento sale
  // de Cloudinary): imprimir antes deja huecos en el papel.
  const lanzar = () => {
    ventana.focus();
    ventana.print();
  };
  if (ventana.document.readyState === 'complete') lanzar();
  else ventana.addEventListener('load', lanzar, { once: true });

  return true;
}
